/* Calc price in Quote Form with Currency App */
window.addEventListener("load", (event) => {
  function replaceDataQuoteProducts() {
    const currencyCode = window.bucksCC.metaConfig.baseCurrency;
    const buckCC = sessionStorage.getItem('buckscc_customer_currency') ? sessionStorage.getItem('buckscc_customer_currency').replace(/"/g, '') : currencyCode;
    const rateBase = window.bucksCC.Currency.rates[buckCC];

    const currencyDecode = decodeHtmlEntities(window.bucksCC.currencyFormats[buckCC].money_format);
    window.OMGRFQConfigs.currency = currencyDecode;

    const products = Object.values(window.omgrfq_productCollection);
    products.forEach((product) => {
      const variants = product.variants;
      variants.forEach((variant) => {
        var rate, priceUSD;
        if (!variant.eit_base_price) {
          rate = variant.price_currency ? window.bucksCC.Currency.rates[variant.price_currency] : window.bucksCC.Currency.rates[currencyCode];
          priceUSD = variant.price * rate;

          // Save base currency
          variant.eit_base_price = variant.price;
          variant.eit_base_price_currency = variant.price_currency;
        } else {
          rate = variant.eit_base_price_currency ? window.bucksCC.Currency.rates[variant.eit_base_price_currency] : window.bucksCC.Currency.rates[currencyCode];
          priceUSD = variant.eit_base_price * rate;
        }

        variant.price = priceUSD / rateBase;
        if (variant.price_currency) {
          variant.price_currency = buckCC;
        }
      });
    });
  }

  function decodeHtmlEntities(str) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = str;
    return textarea.value;
  }

  // Calc first
  var overwrittenData = false;
  document.addEventListener('click', function(event) {
    if (!overwrittenData && event.target.matches('button.omgrfq-btn-quotes')) {
      replaceDataQuoteProducts();
      overwrittenData = true;
    }

    // Compatible Review App vs Eurus sticky Header
    if (event.target.closest('input.jdgm-submit-rev') || event.target.closest('a.jdgm-paginate__page')) {
      setTimeout(() => {
        let element = document.querySelector(`#judgeme_product_reviews`);
        let heightNav = document.querySelector(`.eit-section-nav`).offsetHeight;
        let heightHeader = getComputedStyle(document.documentElement).getPropertyValue('--height-header');
        heightHeader = parseInt(heightHeader, 10);

        let elementPosition = element.offsetTop - heightNav - heightHeader + 1;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth'
        });
      }, 1500);
    }
  }, true);

  // Calc when change currency
  document.addEventListener('BUCKS_SELECTED_CURRENCY', (event) => {
    replaceDataQuoteProducts();
    localStorage.setItem('eit_buckscc_customer_currency', sessionStorage.getItem('buckscc_customer_currency'));
  });

  // Fix issue currency selected default after open new tab
  if (!sessionStorage.getItem('buckscc_customer_currency') && localStorage.getItem("eit_buckscc_customer_currency")) {
    sessionStorage.setItem('buckscc_customer_currency', localStorage.getItem("eit_buckscc_customer_currency"));
  }
});
